/**
 * RULES definition for Contentful operands determination.
 * These are used in string replacements.
 *
 * @type {{OR: string; AND: string}}
 */
export enum Rules {
  'OR' = '|',
  'AND' = ',',
}
